import React from "react";

const CheckMark = () => {
  return (
    <svg
      data-testid="checkmark"
      width="38"
      height="38"
      viewBox="0 0 38 38"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.2032 37.8776C8.94111 37.8776 0.622559 29.559 0.622559 19.297C0.622559 9.03486 8.94111 0.716309 19.2032 0.716309C29.4653 0.716309 37.7839 9.03486 37.7839 19.297C37.7839 29.559 29.4653 37.8776 19.2032 37.8776ZM17.3507 26.7292L30.4872 13.5908L27.8599 10.9635L17.3507 21.4746L12.0942 16.2181L9.46695 18.8454L17.3507 26.7292Z"
        fill="#298200"
      />
    </svg>
  );
};

export default CheckMark;
